module.exports = __webpack_public_path__ + "img/Lei-li-formal-640w.5727a19.jpeg";